/**
 * How CaseViewer lays out its hanging protocol grid. A segmentation study or
 * factory case (an annotation context) keeps the standard 2×2 with all image
 * panes; `segmentationLayout` asks for that same grid without an annotation
 * context (a joint review), so it opens no drawing tools.
 */
export function caseViewerGridLayout({
  enableSegmentation,
  segmentationLayout,
  hasAnnotationContext,
}: {
  enableSegmentation: boolean;
  segmentationLayout: boolean;
  hasAnnotationContext: boolean;
}) {
  return {
    isSegmentationProject: enableSegmentation || segmentationLayout,
    showSegmentationPanel: !hasAnnotationContext && !segmentationLayout,
    forceStandardLayout: hasAnnotationContext || segmentationLayout,
  };
}
